/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * livefeedService
 \*---------------------------------------------------------*/
/* @ngInject */
class HtmlToPlaintext {
  constructor(text) {
    this.text = text;
  }

  stripHtml() {
    return this.text ? String(this.text).replace(/<[^>]+>/gm, '') : '';
  }

  static HtmlToPlaintextFactory(text) {
    const filter = new HtmlToPlaintext(text);
    return filter.stripHtml();
  }
}

const filter = angular
  .module('htmlToPlaintext', [])
  .filter('htmlToPlaintext', () => HtmlToPlaintext.HtmlToPlaintextFactory);

export default filter;



/** WEBPACK FOOTER **
 ** ./client/app/filters/htmlToPlaintext/htmlToPlaintext.js
 **/